// extracted by mini-css-extract-plugin
export var paddingContainerTesting = "TestingHeader-module--padding-container-testing--9598e";